<ng-container *ngFor="let control of _form.controls; index as i">
    <div
        cmpsObservationInteractionNext
        [storePathPrefix]="storePathPrefix"
        [attr.data-trackingid]="_value[i].trackingId"
        [config]="config"
        [published]="published"
        [focus_]="focus"
        [defaultNoteCategory]="defaultNoteCategory"
        [formControl]="control"
    ></div>
</ng-container>
